import { clearGuestFlowAuth } from './guestFlowAuth';
import { clearDeviceLocationCache } from './deviceLocationCache';
import { clearAllGuestKioskState } from '../face-identity/utils/faceIdentityApi';

/** Clear guest QR session and face check-in leftovers after successful proceed. */
export function finalizeGuestQrSession() {
  clearGuestFlowAuth();
  clearDeviceLocationCache();
  clearAllGuestKioskState();
}

/**
 * End guest QR flow and try to close the browser tab.
 * @returns {boolean} true if the tab appears closed
 */
export function attemptCloseGuestTab() {
  finalizeGuestQrSession();
  try {
    window.open('', '_self');
    window.close();
    if (window.closed) return true;
  } catch {
    /* ignore */
  }
  return false;
}
